import { DateTime, Effect } from 'effect';

import * as LocalDate from './LocalDate';
import { centralTime } from './layout';

const sessionOpenHour = 17;

export const tradingDayOf = (self: DateTime.DateTime) => {
  const chicago = DateTime.setZone(self, centralTime);
  const calendarDay = LocalDate.fromDateTime(chicago);
  return DateTime.toParts(chicago).hour >= sessionOpenHour
    ? LocalDate.addDays(calendarDay, 1)
    : calendarDay;
};

export const currentTradingDay = Effect.map(DateTime.now, tradingDayOf);
